import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { selectQuestionsAndOptions, addBookedPatient, addQuestionnaire, delBookedPatientAndQuestionnaire, getExcludeQuestions, getRelationQuestions, getQuestionnaireTypeID as _getQuestionnaireTypeID } from '@/api/module';
import { getOrderCount, addOrder, getSetBookedTime } from '@/api/module/user';
import { Dialog, Toast } from 'vant';
import { getNow } from '@/assets/utils/dateUtil';
import { GetAge } from '@/assets/utils/utils';
import { decrypt } from "@/assets/utils/cryptoUtil";
export default {
  name: "index",
  data: function data() {
    return {
      radio: '0',
      list: [],
      result: [],
      questionList: [],
      //所有问卷问题
      currentQuestion: {},
      //当前问题
      currentIndex: undefined,
      //当前是第几个
      currentPersent: '0%',
      //当前进度
      currentProgress: '0',
      prevText: '返回首页',
      nextText: '下一题',
      allAnswer: new Map(),
      //当前选择的题目答案
      show: false,
      //显示套餐组合
      showPackage: false,
      //显示套餐组合
      showDate: false,
      //显示日历控件
      date: '',
      minDate: new Date(),
      maxDate: new Date(),
      checkDate: undefined,
      //预约体检时间
      orderCount: [],
      //预约排班
      orderArr: new Array(),
      showSuccess: false,
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      user: {},
      //登录用户信息
      basePackage: [],
      //基础体检套餐
      vipPackage: [],
      //尊享VIP套餐
      currentName: '',
      currentPackage: [],
      bookedNo: '',
      fadeEnter: 'fade-enter',
      fadeLeaveActive: 'fade-leave-active',
      extra: [] //是否是额外需要增加的排他项目

    };
  },
  created: function created() {
    this.getList();
    this.getQuestionnaireTypeID();
  },
  filters: {
    typeFilter: function typeFilter(value) {
      if (value == '1') {
        return '（单选）';
      } else if (value == '2') {
        return '';
      } else if (value == '3') {
        return '';
      }
    }
  },
  methods: {
    getQuestionnaireTypeID: function getQuestionnaireTypeID() {
      var _this2 = this;

      var params = {
        typename: "体检检前问卷"
      };

      _getQuestionnaireTypeID(params).then(function (res) {
        if (res.code == 200) {
          _this2.typeid = res.data;
        }
      });
    },
    getList: function getList() {
      var _this3 = this;

      this.user.sexid = this.$route.query.sexId;
      var params = {
        typename: '体检检前问卷'
      };
      selectQuestionsAndOptions(params).then(function (res) {
        if (res.code == 200) {
          if (_this3.user.sexid == '1') {
            _this3.questionList = res.data.filter(function (item) {
              return item.gender != '2';
            });
          } else if (_this3.user.sexid == '2') {
            _this3.questionList = res.data.filter(function (item) {
              return item.gender != '1';
            });
          }

          _this3.currentIndex = 0;
          _this3.currentQuestion = _this3.questionList.find(function (item, index) {
            return index == _this3.currentIndex;
          });

          if (_this3.currentQuestion.optiontype == "3") {
            _this3.result = "";
          }
        }
      });
    },
    //下一题
    toNext: function toNext(item, index) {
      if (this.result.length == 0) {
        Toast.fail('您还未答题');
        return;
      }

      if (this.currentQuestion.optiontype == '2') {
        this.getExcludeQuestions(this.result.join(','), item, index, 0);
      } else if (this.currentQuestion.optiontype == '1') {
        this.getExcludeQuestions(this.result, item, index, 0);
      } else {
        this.toNextFn(item, index);
      }
    },
    toNextFn: function toNextFn(item, index) {
      var _this4 = this;

      if (item != undefined) {
        if (item.title == '男' && this.user.sexid == '2') {
          Toast.fail('您选择的性别和注册资料的性别不符！');
          return;
        }

        if (item.title == '女' && this.user.sexid == '1') {
          Toast.fail('您选择的性别和注册资料的性别不符！');
          return;
        }
      } //检查是否有选择答案


      if (this.result.length == 0) {
        Toast.fail('您还未答题');
        return;
      } // console.log(this.currentIndex)
      // if((this.questionList[0].optiontype=="2" || this.questionList[0].optiontype=="3") && this.questionList.length-1==this.currentIndex){
      //   this.nextText = '提 交';
      // }
      //  2024-3-21 ZLS 修复无法提交的问题


      if (this.questionList.length - 1 == this.currentIndex) {
        this.nextText = '提 交';
      }

      if (this.nextText == '提 交') {
        Dialog.confirm({
          title: '提示',
          message: '所有题目已经答完，确认提交吗？'
        }).then(function () {
          //1、插入问卷表 Questionnaire，问卷答案表
          _this4.insertQuestionnaire();
        }).catch(function (res) {
          console.log("点击了取消", res);
        });
      }

      this.allAnswer.set(this.currentIndex, this.result);

      if (this.currentIndex + 1 < this.questionList.length) {
        this.prevText = '上一题'; //下一题

        this.currentIndex++;
        this.currentQuestion = this.questionList.find(function (item, index) {
          return index == _this4.currentIndex;
        });
        this.getCurrentProcess(); //下一题，如果有选择了的，则赋值选择了的答案
        //如果没有选择的，则清空

        this.result = [];
        this.allAnswer.forEach(function (value, key) {
          if (_this4.currentIndex == key) {
            _this4.result = value;
          }
        });
        this.fadeEnter = 'fade-enter';
        this.fadeLeaveActive = 'fade-leave-active';
      }
    },
    //获取排他题目
    getExcludeQuestions: function getExcludeQuestions(optionId, pitem, index, flag) {
      var _this5 = this;

      var _this = this;

      var param = {
        optionId: optionId
      };
      getRelationQuestions(param).then(function (res) {
        if (res.code == 200) {
          if (res.data != null && res.data.length > 0) {
            _this5.$nextTick(function () {
              if (res.data.length > 0) {
                _this5.questionList = _this5.getREQuestions(res.data, flag);

                if (pitem != undefined) {
                  var oldVal = _this5.allAnswer.get(_this5.currentIndex);

                  if (oldVal != undefined && oldVal != _this5.result && _this5.currentQuestion.optiontype == "1") {
                    _this5.getExcludeQuestionsReverse(oldVal, pitem, index);
                  } else {
                    _this5.toNextFn(pitem, index);
                  }
                } else {
                  console.log("有关联项目设置提交按钮");

                  if (_this5.currentIndex + 1 == _this5.questionList.length) {
                    _this5.nextText = "提 交";
                  }

                  if (_this5.currentIndex + 1 < _this5.questionList.length) {
                    _this5.nextText = "下一题";
                  }
                }
              }
            });
          } else {
            if (pitem != undefined) {
              var oldVal = _this5.allAnswer.get(_this5.currentIndex);

              if (oldVal != undefined && oldVal != _this5.result && _this5.currentQuestion.optiontype == "1") {
                _this5.getExcludeQuestionsReverse(oldVal, pitem, index);
              } else {
                _this5.toNextFn(pitem, index);
              }
            } else {
              console.log("没有关联项目设置提交按钮");

              if (_this5.currentIndex + 1 == _this5.questionList.length) {
                _this5.nextText = "提 交";
              }

              if (_this5.currentIndex + 1 < _this5.questionList.length) {
                _this5.nextText = "下一题";
              }
            }
          }
        }
      });
    },
    //处理单选题返回重新选答案变化的关联排他处理
    getExcludeQuestionsReverse: function getExcludeQuestionsReverse(optionId, pitem, index) {
      var _this6 = this;

      var _this = this;

      var param = {
        optionId: optionId
      };
      getRelationQuestions(param).then(function (res) {
        if (res.code == 200) {
          if (res.data != null && res.data.length > 0) {
            _this6.$nextTick(function () {
              if (res.data.length > 0) {
                _this6.questionList = _this6.getREQuestions(res.data, 1);

                _this6.toNextFn(pitem, index);
              }
            });
          } else {
            _this6.toNextFn(pitem, index);
          }
        }
      });
    },
    //处理关联排他题目
    getREQuestions: function getREQuestions(resData, flag) {
      var _this7 = this;

      var ques = [];
      var ques1 = [];
      var excludeData = resData.filter(function (item) {
        return item.relationtype == "2";
      });
      var relationData = resData.filter(function (item) {
        return item.relationtype == "1";
      });

      if (flag == 0) {
        if (excludeData.length > 0) {
          this.questionList.forEach(function (item) {
            //排除排他问题
            for (var i = 0; i < excludeData.length; i++) {
              if (excludeData[i].questionid !== item.questionid) {
                ques.push(item);
                continue;
              } else {
                _this7.extra.push(item);
              }
            }
          });
        } else {
          ques = this.questionList;
        } //处理关联问题


        relationData.forEach(function (item) {
          for (var i = 0; i < ques.length; i++) {
            if (item.questionid !== ques[i].questionid) {
              ques1.push(item);
              break;
            }
          }
        });
        ques = ques.concat(ques1);
        var map = new Map();
        var arr = ques.filter(function (key) {
          return !map.has(key.questionid) && map.set(key.questionid, 1);
        }); // 这里对questionid属性进行去重

        return arr;
      } else {
        //当复选框取消选中的时候则反向操作
        if (relationData.length > 0) {
          this.questionList.forEach(function (item) {
            //关联的要排除掉
            for (var i = 0; i < relationData.length; i++) {
              if (resData[i].questionid !== item.questionid) {
                ques.push(item);
              }
            }
          });
        } else {
          ques = this.questionList;
        } //如果是是移除的排他题目要加回去


        var thisExtra = this.extra;
        excludeData.forEach(function (item) {
          for (var i = 0; i < ques.length; i++) {
            if (item.questionid !== ques[i].questionid && item.relationtype === "2") {
              if (thisExtra.length > 0) {
                for (var j = 0; j < thisExtra.length; j++) {
                  if (item.questionid == thisExtra[j].questionid) {
                    ques1.push(item);
                    break;
                  }
                }
              }

              break;
            }
          }
        });
        ques = ques.concat(ques1);

        var _map = new Map();

        var _arr = ques.filter(function (key) {
          return !_map.has(key.questionid) && _map.set(key.questionid, 1);
        }); // 这里对questionid属性进行去重


        return _arr;
      }
    },
    //上一题
    toPrev: function toPrev() {
      var _this8 = this;

      if (this.prevText == '返回首页') {
        Dialog.confirm({
          title: '提示',
          message: '您的问卷结果会被清除，确定要返回吗？'
        }).then(function () {
          var param = {
            bookedNo: _this8.bookedNo
          };
          delBookedPatientAndQuestionnaire(param).then(function (res) {
            if (res.code == 200) {
              Toast(res.msg);
            }
          });

          _this8.$router.push({
            name: 'home'
          });
        });
      } else {
        //删除当前题目的答案
        this.allAnswer.delete(this.currentIndex); //上一题，给前面题目赋答案

        this.result = [];
        this.allAnswer.forEach(function (value, key) {
          if (_this8.currentIndex - 1 == key) {
            _this8.result = value;
          }
        });
      }

      if (this.currentIndex != 0) {
        if (this.currentIndex == 1) {
          this.prevText = '返回首页';
        } else {
          this.prevText = '上一题';
          this.nextText = '下一题';
        }

        this.currentIndex--;
        this.currentQuestion = this.questionList.find(function (item, index) {
          return index == _this8.currentIndex;
        });
        this.getCurrentProcess();
        this.fadeEnter = 'fade-enter2';
        this.fadeLeaveActive = 'fade-leave-active2';
      }
    },
    toggle: function toggle(item, index) {
      this.$refs.checkboxes[index].toggle();

      if (this.$refs.checkboxes[index].checked) {
        this.getExcludeQuestions(item.optionsid, undefined, index, 1);
      } else {
        this.getExcludeQuestions(item.optionsid, undefined, index, 0);
      }
    },
    getCurrentProcess: function getCurrentProcess() {
      this.currentProgress = parseInt(this.currentIndex) / parseInt(this.questionList.length) * 100;
      this.currentPersent = this.currentProgress.toFixed(0) + '%';
    },
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    selectDate: function selectDate(date) {
      var newDate = new Date();
      this.showDate = false;

      if (this.formatDate(date) == this.formatDate(new Date())) {
        return;
      }

      this.checkDate = this.formatDate(date);
      this.getSetBookedTime(this.checkDate);
    },
    formatter: function formatter(day) {
      var _this9 = this;

      var year = day.date.getFullYear();
      var month = day.date.getMonth() + 1;
      var date = day.date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (date < 10) {
        date = '0' + date;
      }

      var days = year + '-' + month + '-' + date;
      this.orderCount.forEach(function (item) {
        if (item.bookeddate == days) {
          if (item.status == '0') {
            day.bottomInfo = '休息';
            day.type = "disabled";
          } else if (item.status == '1') {
            var personCount = 0;

            if (parseInt(item.mennumber) > 0 || parseInt(item.womenmumber) > 0) {
              if (_this9.user.sexid == "1") {
                personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
              }

              if (_this9.user.sexid == "2") {
                personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
              }
            } else {
              personCount = parseInt(item.bookednumber) - parseInt(item.already);
            }

            if (personCount <= 0) {
              day.bottomInfo = '余 0';
              day.type = "disabled";
            } else {
              if (days <= _this9.getNow()) {
                day.type = "disabled";
              }

              day.bottomInfo = '余 ' + personCount;
            }
          }
        }
      }); //将所有的没有排期的设置为休息日

      if (!this.orderArr.includes(days)) {
        var nextMonthStr = "";
        var nextMonth = this.getNextMonth();
        var nextM = nextMonth.getMonth() + 1;
        var nextD = nextMonth.getDate();

        if (nextM < 10) {
          nextM = '0' + nextM;
        }

        if (nextD < 10) {
          nextD = '0' + nextD;
        }

        nextMonthStr = nextMonth.getFullYear() + '-' + nextM + '-' + nextD; //已经过去的时间不显示文字

        if (days >= this.getNow() && days <= nextMonthStr) {
          day.bottomInfo = '休息';
          day.type = "disabled";
        }
      }

      return day;
    },
    getNow: function getNow() {
      var d = new Date();
      var yy1 = d.getFullYear();
      var mm1 = d.getMonth() + 1;

      if (mm1 < 10) {
        mm1 = '0' + mm1;
      }

      var dd1 = d.getDate();

      if (dd1 < 10) {
        dd1 = '0' + dd1;
      }

      return yy1 + '-' + mm1 + '-' + dd1;
    },
    insertQuestionnaire: function insertQuestionnaire() {
      var _this10 = this;

      if (this.allAnswer.size == this.questionList.length) {
        var questionnaireAnswerList = new Array();
        this.questionList.forEach(function (item, i) {
          _this10.allAnswer.forEach(function (jtem, j) {
            if (i == j) {
              if (jtem instanceof Array) {
                jtem.forEach(function (ktm) {
                  var questionnaireAnswer = {
                    questionid: item.questionid,
                    result: ktm
                  };
                  questionnaireAnswerList.push(questionnaireAnswer);
                });
              } else {
                var questionnaireAnswer = {
                  questionid: item.questionid,
                  result: jtem
                };
                questionnaireAnswerList.push(questionnaireAnswer);
              }
            }
          });
        });
        var id = this.$route.query.id;
        var serialno = this.$route.query.serialno;
        var bookedNo = this.$route.query.bookedNo;
        var typeid = this.$route.query.typeid;
        var param = {
          id: id,
          bookedNo: bookedNo,
          serialNo: serialno,
          physicalNo: this.user.physicalno,
          typeID: typeid,
          companyid: "0000",
          comapnytimes: "1",
          checkline: "1",
          institutionid: window.g.VUE_APP_INSTITUTIONID,
          questionnaireAnswerList: questionnaireAnswerList,
          patientID: this.user.patientid,
          name: this.user.name,
          sexID: this.user.sexid,
          // birthDate: this.user.birthdate.substring(0,10),
          marital: this.user.marital,
          phone: this.user.phone
        };
        console.log("allAnswer", this.allAnswer);
        addQuestionnaire(param).then(function (res) {
          if (res.code == 200) {
            var pageName = _this10.$route.query.pageName;
            var pageParams = _this10.$route.query.pageParams;

            if (pageName && pageParams) {
              if (pageName == "companyOrder") {
                _this10.$router.push({
                  name: pageName,
                  query: {
                    item: pageParams
                  }
                });
              }

              if (pageName == "packageDetail") {
                _this10.$router.push({
                  name: pageName,
                  query: {
                    packageId: pageParams
                  }
                });
              }
            } else {
              _this10.$router.push({
                name: 'preconsultation'
              });
            }
          }
        });
      }
    },
    showPackageInfo: function showPackageInfo(name, type) {
      if (type == 'base') {
        this.currentPackage = this.basePackage;
      } else if (type == 'vip') {
        this.currentPackage = this.vipPackage;
      }

      this.currentName = name;
      this.showPackage = true;
    },
    whycheck: function whycheck(str) {
      Dialog.alert({
        title: '提示',
        message: str
      }).then(function () {// on close
      });
    }
  }
};